interface StyleConfig {
  key: string;
  title: string;
  description: string;
  additionalProps?: Record<string, any>;
  wrapper?: string;
  wrapperProps?: Record<string, any>;
}

interface StyleLayoutItem {
  gridSize: { xs: number; md?: number };
  components: StyleConfig[];
  wrapper?: string;
  wrapperProps?: Record<string, any>;
}

export const previewCallAnalyticsStyleLayout: StyleLayoutItem[] = [
  {
    gridSize: { xs: 12, md: 4 },
    components: [
      {
        key: 'call_statistics_overview.total_calls',
        title: 'Total Calls',
        description: '',
        additionalProps: {}
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 4 },
    components: [
      {
        key: 'call_statistics_overview.total_call_duration',
        title: 'Total Duration',
        description: '',
        additionalProps: {}
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 4 },
    components: [
      {
        key: 'call_statistics_overview.average_call_duration',
        title: 'Avg Call Duration',
        description: '',
        additionalProps: {}
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'call_volume_by_type',
        title: 'Call Volume Over Time',
        description: 'Top 10 days when mostly group and peer calls were made during the selected time frame',
        additionalProps: {
          dataKeys: ['group', 'peer'],
          height: 550,
          graphHeight: 430,
          xAxisKey: 'day',
          colors: ['#8B5CF6', '#3B82F6'],
          xAxisTitle: 'Date',
          yAxisTitle: 'Number of Calls'
        }
      }
    ]
  },
  {
    gridSize: { xs: 6 },
    components: [
      {
        key: 'calls_heatmap',
        title: 'Peak Calling Hours',
        description: 'This heatmap indicates the hour of the day and the number of concurrent calls made during that hour for the selected time frame.',
        additionalProps: {
          height: 550,
          graphHeight: 400,
          colorScale: { low: '#E0E7FF', medium: '#A78BFA', high: '#7C3AED' },
          xAxisLabel: 'Hour',
          yAxisLabel: 'Date'
        }
      }
    ]
  },
  {
    gridSize: { xs: 6 },
    components: [
      {
        key: 'group_calls_heatmap',
        title: 'Group Calls',
        description: 'This heatmap indicates the hour of the day and the number of group calls made during that hour for the selected time frame.',
        additionalProps: {
          height: 550,
          graphHeight: 400,
          colorScale: { low: '#E0E7FF', medium: '#A78BFA', high: '#7C3AED' },
          xAxisLabel: 'Hour',
          yAxisLabel: 'Date'
        }
      }
    ]
  },
  {
    gridSize: { xs: 6 },
    components: [
      {
        key: 'peer_calls_heatmap',
        title: 'Private Calls',
        description: 'This heatmap indicates the hour of the day and the number of private calls made during that hour for the selected time frame.',
        additionalProps: {
          height: 550,
          graphHeight: 400,
          colorScale: { low: '#E0E7FF', medium: '#A78BFA', high: '#7C3AED' },
          xAxisLabel: 'Hour',
          yAxisLabel: 'Date'
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'call_duration_distribution',
        title: 'Call Duration Distribution',
        description: 'Distribution of call durations in different time ranges',
        additionalProps: {
          dataKeys: ['count'],
          xAxisKey: 'duration',
          colors: ['#F59E0B'],
          height: 450,
          graphHeight: 350,
          xAxisTitle: 'Duration Range',
          yAxisTitle: 'Number of Calls'
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'call_quality_distribution',
        title: 'Audio vs Video Calls',
        description: 'A pie chart showing the proportion of audio calls and video calls made during the selected time frame',
        additionalProps: { height: 450, graphHeight: 320}
      }
    ]
  }
];